<template>
    <div>
        <example-description
                subject="테이블 기본 레이아웃 그리드"
        />
        <base-table-layout
                :headers="headers"
                :items="items"
        >
        </base-table-layout>

        <example-description
                subject="테이블 기본 레이아웃 header slot"
        />
        <base-table-layout
                :headers="headers"
                :items="items"
        >
            <template #header>
                Header Slot
            </template>
        </base-table-layout>

        <example-description
                subject="테이블 기본 레이아웃 header.{key} slot"
        />
        <base-table-layout
                :headers="headers"
                :items="items"
        >
            <template #header.text>
                Header Text Slot
            </template>
        </base-table-layout>

        <example-description
                subject="테이블 기본 레이아웃 item slot"
        />
        <base-table-layout
                :headers="headers"
                :items="items"
        >
            <template #item>
                Item Slot Content
            </template>
        </base-table-layout>

        <example-description
                subject="테이블 기본 레이아웃 item.{key} slot"
        />
        <base-table-layout
                :headers="headers"
                :items="items"
        >
            <template #item.text>
                Item Text Slot
            </template>
        </base-table-layout>
    </div>
</template>

<script>
    import BaseTableLayout from "@/assets/plugins/mps-form-table/component/base-table-layout";
    import ExampleDescription from "@/components/example/ExampleDescription";
    export default {
        name: "ExampleBaseTableLayout",
        components: {ExampleDescription, BaseTableLayout},
        data() {
            return {
                headers: [
                    {
                        text: "아이디",
                        key: "id",
                        width: "100px",
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: "300px",
                    },
                ],
                items: [
                    {
                        id: "test",
                        text: "테스트",
                    },
                    {
                        id: "test2",
                        text: "테스트2",
                    },
                    {
                        id: "test3",
                        text: "테스트3",
                    },
                    {
                        id: "test4",
                        text: "테스트4",
                    },
                    {
                        id: "test5",
                        text: "테스트5",
                    },
                ],
            }
        }
    }
</script>

<style scoped>

</style>